import { Component, Inject } from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-meeting-schedule-warning-dialog',
    imports: [MatDialogModule, MatIcon,],
  templateUrl: './meeting-schedule-warning-dialog.component.html',
  styleUrl: './meeting-schedule-warning-dialog.component.scss'
})
export class MeetingScheduleWarningDialogComponent {

    constructor(
        private dialogRef: MatDialogRef<MeetingScheduleWarningDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { time: string }
    ) {}

    onCancel() {
        this.dialogRef.close(false);
    }

    onConfirm() {
        this.dialogRef.close(true);
    }
}
